<template>
<ul class="pagination">
  <li v-for="val in paginationItems" :key="val">
      <a href="#"
         :title="val"
         @click.prevent="update(val)"
         class="page-numbers"
         :class="{'current': isActive(val)}">
          {{ val }}
      </a>
  </li>
</ul>
</template>

<script>
export default {
  name: "GalleryPagination",

  props: {
    paginationItems: Number,
    activeNumber: Number
  },

  methods: {
    update(val) {
      this.$emit("paginationUpdate", val);
    },

    isActive(key) {
      if (this.activeNumber == (key - 1)) {
        return true;
      }

      return false;
    }
  }
}
</script>
